import type {
    GetFacultiesResponseType,
    GetFacultiesRequestType
} from "./type";
import {
    request
} from "../request";

const getFaculties = async (
    params: GetFacultiesRequestType
): Promise<GetFacultiesResponseType> => {
    return await request<GetFacultiesResponseType>(`/staticData/getFaculties?universityID=${params.universityID}`, {
        method: "GET"
    });
};

export default getFaculties;
